import { render, staticRenderFns } from "./QandA.vue?vue&type=template&id=2d9f4d19&scoped=true"
import script from "./QandA.vue?vue&type=script&lang=js"
export * from "./QandA.vue?vue&type=script&lang=js"
import style0 from "./QandA.vue?vue&type=style&index=0&id=2d9f4d19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f4d19",
  null
  
)

export default component.exports